export default __webpack_public_path__ + "static/media/1.d91e1d8a.jpg";